var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout-wrapper layout-content-navbar",attrs:{"id":"app"}},[_c('div',{staticClass:"layout-container"},[_c('router-view')],1),_c('div',{staticClass:"layout-overlay layout-menu-toggle"})])
}
var staticRenderFns = []

export { render, staticRenderFns }